var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeopleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.14551 17.5903C1.14551 15.9738 1.78767 14.4234 2.93073 13.2803C4.07378 12.1373 5.6241 11.4951 7.24062 11.4951C8.85715 11.4951 10.4075 12.1373 11.5505 13.2803C12.6936 14.4234 13.3357 15.9738 13.3357 17.5903H1.14551ZM7.24062 10.7332C4.71496 10.7332 2.66929 8.68748 2.66929 6.16176C2.66929 3.63605 4.71496 1.59033 7.24062 1.59033C9.76629 1.59033 11.812 3.63605 11.812 6.16176C11.812 8.68748 9.76629 10.7332 7.24062 10.7332Z",
    stroke: "#00357A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5747 2.35205C14.469 2.35205 16.0032 4.20294 16.0032 6.48811C16.0032 8.77328 14.469 10.5516 12.5747 10.5516C13.7871 10.5516 14.9498 11.1326 15.8071 12.1668C16.6644 13.201 17.146 14.6037 17.146 16.0663H15.1869",
    stroke: "#00357A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleIcon);
export default __webpack_public_path__ + "static/media/peopleIcon.bcc243acf099f2c74b17bab4544d959a.svg";
export { ForwardRef as ReactComponent };